var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen"},[_c('iframe',{staticClass:"rounded h-full w-full h-dashboard-pcp",attrs:{"src":_vm.dashboardUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }